/**
 * Copyright (c) 2025 Bytedance, Inc. and its affiliates.
 * SPDX-License-Identifier: Apache-2.0
 */
export const GUI_ADAPTED_TOOL_NAME = 'browser_vision_control';
